import { useEffect } from 'react';

import { useCustomLocation } from '../../router/navigation';
import { HOME_PATH } from '../../router/paths';

const CanonicalLink = () => {
  const location = useCustomLocation();

  useEffect(() => {
    const canonicalLinkTag =
      document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]') ??
      document.head.appendChild(document.createElement('link'));

    const getCanonicalHref = () => {
      const pathname = location.pathname.replace(/\/+$/, '') || HOME_PATH;
      return `${window.location.origin}${pathname}`;
    };

    canonicalLinkTag.rel = 'canonical';
    canonicalLinkTag.href = getCanonicalHref();
  }, [location.pathname]);

  return null;
};

export default CanonicalLink;
